import { Components, Theme } from '@mui/material';

import { alpha } from '@mui/material/styles';

export const BADGE_HEIGHT = {
  SMALL: 16,
  MEDIUM: 20,
  LARGE: 24,
};

export default {
  defaultProps: {
    variant: 'standard',
    color: 'primary',
  },
  styleOverrides: {
    badge: ({ theme }) => ({
      boxSizing: 'border-box',
      minWidth: 16,
      '&.MuiBadge-size-small': {
        height: BADGE_HEIGHT.SMALL,
        padding: theme.spacing(0, 0.5),
        ...theme.typography.captionBold
      },
      '&.MuiBadge-size-medium': {
        height: BADGE_HEIGHT.MEDIUM,
        padding: theme.spacing(0, 1),
        ...theme.typography.overlineBold
      },
      '&.MuiBadge-size-large': {
        height: BADGE_HEIGHT.LARGE,
        padding: theme.spacing(0, 1.25),
        ...theme.typography.body2Bold
      },
      '&.MuiBadge-corner-round': {
        borderRadius: 8,
      },
      '&.MuiBadge-inline': {
        position: 'relative',
        transform: 'none',
      },
    }),
    standard: ({ theme, ownerState }) => {
      return {
        backgroundColor: theme.palette[ownerState.color!].main,
        color: theme.palette[ownerState.color!].onMain,
        '&.MuiBadge-inverse': {
          backgroundColor: theme.palette.neutral.containerHighest,
          color: theme.palette.neutral.onSurface,
        }
      };
    },
    outlined: ({ theme, ownerState }) => {
      return {
        backgroundColor: theme.palette.neutral.surface,
        color: theme.palette.neutral.onSurface,
        border: '1px solid',
        borderColor: theme.palette[ownerState.color!].outline,
        '&.MuiBadge-inverse': {
          backgroundColor: theme.palette.neutral.inverse,
          borderColor: theme.palette.neutral.containerHighest,
          color: theme.palette.neutral.onInverse,
        }
      };
    },
    subtleOutlined: ({ theme, ownerState }) => {
      return {
        backgroundColor: theme.palette.neutral.surface,
        color: theme.palette.neutral.onSurface,
        border: '1px solid',
        borderColor: theme.palette[ownerState.color!].outlineVariant,
        '&.MuiBadge-inverse': {
          backgroundColor: theme.palette.neutral.inverse,
          borderColor: alpha(theme.palette.common.white, 0.20),
          color: theme.palette.neutral.onInverse,
        }
      };
    },
    tonal: ({ theme, ownerState }) => {
      return {
        backgroundColor: theme.palette[ownerState.color!].container,
        color: theme.palette[ownerState.color!].onContainer,
        '&.MuiBadge-inverse': {
          backgroundColor: alpha(theme.palette.common.white, 0.12),
          color: theme.palette.neutral.onInverse,
        }
      };
    },
    dot: ({ theme }) => ({
      minWidth: 8,
      '&.MuiBadge-size-small, &.MuiBadge-size-medium, &.MuiBadge-size-large': {
        padding: 0,
        width: 8,
        height: 8,
      },
      '&.MuiBadge-inverse': {
        backgroundColor: theme.palette.neutral.containerHighest,
        color: theme.palette.neutral.onSurface,
      }
    }),
  }
} as Components<Theme>['MuiBadge'];